var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.data.src,"type":"audio/mpeg"}})]),_vm._v(" "),(_vm.data.caption)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.data.caption))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52533d0b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/content-module/audio.vue
// module id = null
// module chunks = 